import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useRankingCareer = (groupName) => {
  const localPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['rankingCareer', groupName],
    queryFn: async () => {
      const result = await restClient({ url: `${localPrefix}/rankings/careers/${groupName}` });
      return result;
    },
    enabled: !!groupName, 
    staleTime: 0,
    cacheTime: 0
  });
};
